import React from 'react';
import { Typography, Card, CardContent, CardActions, Button } from '@mui/material';

interface IFeedItemProps {
  title: string;
  link: string;
  date: string;
  content: string;
}

const FeedItem: React.FC<IFeedItemProps> = (props: IFeedItemProps) => {
  const { title, link, date, content } = props;
  const options: Intl.DateTimeFormatOptions = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = new Date(date).toLocaleDateString('en-US', options);
  return (
    <Card className='feed-item' style={{ backgroundColor: '#2E3036' }}>
      <CardContent>
        <Typography className='text-white' variant='h6' style={{ fontSize: '16px' }} >
          {title}
        </Typography>
        <Typography className='text-white' variant='body2'>
          {formattedDate}
        </Typography>
        <br />
        <Typography className='text-white' variant='body2'>
          {content}
        </Typography>
      </CardContent>
      <CardActions>
        <a href={link} target='_blank' rel='noreferrer'>
          <Button style={{ color: '#4895EF' }} size='medium'>Read More</Button>
        </a>
      </CardActions>
    </Card>
  );
};

export default FeedItem;
